import React, {useState, useEffect, useRef, useMemo} from "react";
import "./App.css"

import RecordingButton from "./RecordingButton"
import HistoryPopup from "./HistoryPopup";

import {useStats} from "./StatsContext";
import {useLessons} from "./DataContext";
import ScoreBox from "./ScoreBox";
import {localStorageGetItem,localStorageSetItem,localStorageRemoveItem, getSpeech2Text} from "./misc";
import WhisperUploader from "./whisper";
import {removeNekudot} from "./nekudot";

//
// Possible structures of gameParams.texts
//
// if 'words' : array of {formes: ms: [], cat: ..., lesson: , type: 'words'}
// if 'sentences" : array of {exData: [], lesson: , type: 'sentences'}
// if 'versions' (or themes) : array of {title:, exDatas :Array of [], lesson: , type: 'versions'}
//

const Game = ({gameParams, onEndGame}) => {

    console.log("GAMEPARAMS",gameParams)

    const {onLeaveStatsContext, getExScore} = useStats();
    const {flattenTexts} = useLessons();

    const exerciseRef = useRef(null);
    const ExerciseElement = gameParams.element;

    const [title, setTitle] = useState(null);
    const [hasNequdotButton, setHasNequdotButton] = useState(true);
    const [nequdotButtonValue, setNequdotButtonValue] = useState(0);
    const [hasHistoryButton, setHasHistoryButton] = useState(null);
    const [recordingDisabled, setRecordingDisabled] = useState(false);
    const [readDisabled, setReadDisabled] = useState(false);
    const [recordedText, setRecordedText] = useState(null);
    const [isEndEx, setIsEndEx] = useState(false);


    // Flag that indicates if the exercise is revealed or not
    const [revealed, setRevealed] = useState(() => {
        return JSON.parse(localStorageGetItem('revealed')) || false;
    })
    useEffect(() => {
        localStorageSetItem('revealed', JSON.stringify(revealed));
    }, [revealed]);

    useEffect(() => {
        let alreadyRun = exerciseRef.current?.__didInit;
        if (alreadyRun) return;
        exerciseRef.current.__didInit = true;
console.log("SPE 1")
        setTitle(gameParams.title);
        setHasHistoryButton(exerciseRef.current.getFlags().hasHistoryButton);
        exerciseRef.current.nextEx();
    }, [])

    useEffect(() => {
        setRecordingDisabled(exerciseRef.current.isRecordingDisabled());
        setReadDisabled(exerciseRef.current.getFlags().isReadDisabled);
        setIsEndEx(exerciseRef.current.isEndEx());
    }, [revealed])

    const onRecording = (text) => {
        const [flagSuccess,match] = exerciseRef.current.isRecordingSuccess(text);
        setRecordedText([flagSuccess,match])
        if (flagSuccess) {
            exerciseRef.current.readHebrewText();
            setRevealed(true);
        }
    }

    const [history, setHistory] = useState([]);
    const addHistoryEntry = ({text1, lang1, text2, lang2, textWithVowels}) => {
        const text = {
            index: 1,
            lang1: lang1,
            text1: text1,
            lang2: lang2,
            text2: text2,
            textWithVowels: textWithVowels
        }
        setHistory([...history, text]);
    };

    // Exercice score management
    const [exScore, setExScore] = useState(0);
    const computeExScore = () => {
        const score = getExScore(gameParams.choice[1],gameParams.mode,flattenTexts(gameParams.texts));
        console.log("SCORE GAME",score, gameParams)
        setExScore(score);
    }
    useEffect(() => computeExScore(), []);

    // Main buttons management
    const [isOver,setIsOver] = useState(false);

    // n = -1 ==> second button is pushed
    // n>= 0 one of the first ones
    const onPushMainButtons = (n) => {
        if (revealed) setRecordedText(null);
        // Not QCM
        if (!exerciseRef.current.getFlags().isQCM) {
            if (isOver) {
                endGame()
                return;
            }
            if (revealed || !exerciseRef.current?.getFlags().hasRevealPhase) {
                exerciseRef.current.notifySuccess(n === 0);
                if (!exerciseRef.current.isEndEx()) {
                    exerciseRef.current.nextEx(true);
                    setRevealed(false);
                } else setIsOver(true);
            } else setRevealed(true);
        }

        // QCM case
        else {
            if (!revealed) {
                setQCMAnswer(n);
                const solution = exerciseRef.current.getQCMSolution();
                exerciseRef.current.notifySuccess(n===solution);
                setRevealed(true);
            }
            else {
                 if (!exerciseRef.current.isEndEx()) {
                    exerciseRef.current.nextEx(true);
                    setRevealed(false);
                 } else setIsOver(true);
                 setQCMAnswer(null);
            }
        }
        computeExScore();
    }

    const [mainButtons1, setMainButtons1] = useState([]);
    const [QCMAnswer, setQCMAnswer] = useState(-1);
    const [mainButton2Title, setMainButton2Title] = useState("");
    useEffect(() => {
        const isqcm =  exerciseRef.current?.getFlags().isQCM;
        if (isqcm===null) return

        // Case not a QCM
        if (isqcm === false ) {
            let t = "";
            if (isOver) t=["C'est fini !"];
            else if (revealed) t=[(!exerciseRef.current.isEndEx() ? "J'ai réussi, je continue" : "J'ai réussi")];
            else t=["Solution"];
            setMainButtons1([{lang: 'f', title: t, good: null}])

            if (isOver) setMainButton2Title("");
            else if (revealed) setMainButton2Title(!exerciseRef.current.isEndEx() ? "J'ai raté, je continue" : "J'ai raté")
            else setMainButton2Title("");
        }

        // Case of a QCM
        else {
            const QCMSolution =  (revealed ? exerciseRef.current.getQCMSolution() : null) ;
            setMainButtons1(exerciseRef.current.getQCMList().map((t,index) => {
                return {
                    lang: t.lang,
                    title: t.title,
                    good: (revealed ? index===QCMSolution : null)
                }
            }))
            if (revealed) setMainButton2Title((QCMSolution===QCMAnswer ? "J'ai réussi" :  "J'ai raté")+", je continue")
            else setMainButton2Title("stupid");
        }
        }, [revealed,isOver,QCMAnswer]
    );


    const [isNequdotActive, setIsNequdotActive] = useState(false);
    useEffect(() => {
        const check = exerciseRef.current?.isNequdotActive?.();
        setIsNequdotActive(check);
        }, [mainButtons1,mainButton2Title,revealed]);


    // End game cleaning
    const endGame = () => {
        exerciseRef.current.endEx();
        localStorageRemoveItem('revealed');
        localStorageRemoveItem('currentText');
        onLeaveStatsContext();
        onEndGame();
    }

    return (

        <div className="main-container">
            <div className="title-container top">
                <button onClick={() => {
                    endGame();
                }}>
                    ⬅️
                </button>
                <div className="title-container-title">
                    {title}
                </div>
            </div>
            <div className={"section-container"}>
                {hasNequdotButton || hasHistoryButton ?
                    (<div className={"section-container-line"}>
                        {hasNequdotButton
                            ? <button className="nequdotGameButton"
                                disabled={!isNequdotActive}
                                onClick={() => {
                                    let value = nequdotButtonValue==='1' ? false : true
                                    exerciseRef.current?.nequdotClick?.(value)
                                    setNequdotButtonValue(nequdotButtonValue==='1' ? '0' : '1')
                                }}
                                >
                                {nequdotButtonValue==='1' ? "נקדות" : "נְקֻדּוֹת" }
                            </button>
                            : null}

                        <div className={"score-ex"}>
                            Score exercice : <ScoreBox score = {exScore} />
                        </div>
                        <div>
                        {hasHistoryButton
                            ? <HistoryPopup history={history} setHistory={setHistory}/>
                            : null}
                            </div>
                    </div>)
                    : null
                }
                <ExerciseElement ref={exerciseRef} gameParams={gameParams} revealed={revealed}
                                 addHistoryEntry={addHistoryEntry}/>
                <div className={"section-container-line"}>
                    <div className={"recordedText-container"}>
                        {recordedText
                            ? <>
                                <span dir={"ltr"}> {(recordedText[0] ? "✅" : "❌")} </span>
                                {
                                    recordedText[1].map(([text, flag], i) =>
                                        <span key={i} className={flag ? "correct" : "incorrect"}>
                                            {text}
                                        </span>
                                    )
                                }
                                </>
                            : (<span>&nbsp;</span>)
                        }
                    </div>
                </div>


                <div className="game-audio-buttons-div">
                    <button className=""
                            onClick={() => exerciseRef.current.readHebrewText()}
                            disabled={readDisabled}
                    >
                        🔊
                    </button>
                        {getSpeech2Text()==='webapi'
                            ?  <RecordingButton onStart={() => setRecordedText("")} disabled={recordingDisabled} onResult={onRecording}/>
                            :                     <WhisperUploader onStart={() => setRecordedText("")} disabled={recordingDisabled} onResult={onRecording}/>
                        }

                </div>
            </div>

            <div className="title-container game-main-buttons">
                <div className="section-container-line">
                {mainButtons1.map((button,index) => {
                    return(
                    <button key={index} onClick={() => {
                        onPushMainButtons(index)}}>
                        {button.title + (revealed && button.good !== null ? (button.good ? " ✅" : " ❌") : "")}
                    </button>)
                })}
                </div>
                <button
                    className={
                        (isOver || (!revealed && exerciseRef.current?.getFlags().hasRevealPhase)
                            ? "invisible "
                            : "") +
                        (mainButton2Title.includes("rat") && exerciseRef.current?.getFlags().isQCM ? " missed-button" : "")}
                    onClick={() => {onPushMainButtons(-1)}}>
                    {mainButton2Title}
                </button>
            </div>
        </div>
    );
};

export default Game;
